module.exports = __webpack_public_path__ + "my-analysis-icon.png?7b78b97f7b0b8e7d3fdee0d308e224f5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/my-analysis-icon.png
// module id = 122
// module chunks = 0